window.addEventListener('DOMContentLoaded', event => {
  document.documentElement.style.setProperty('--viewport-width', `${document.body.clientWidth}px`);
  window.addEventListener('resize', event => {
    document.documentElement.style.setProperty('--viewport-width', `${document.body.clientWidth}px`);
  });
});
